module.exports = __webpack_public_path__ + "static/media/lodestar-circle.5df04efe.png";